import { useSyncExternalStore } from 'react';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

export const useNewVideoTagInPreview = () => {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);

  return {
    useNewVideoTag: !!featureFlags[FeatureFlagKeys.Use_CL_New_Video_Tag_In_Preview]
  };
};
